document.addEventListener('DOMContentLoaded', function() {
  // DOM Elements & Variant Data Initialisation
  const container = document.querySelector('.product-v2-container');
  if (!container) return;

  const sectionId = container.id.replace('MainProduct-', '');
  const jsonElement = document.getElementById(`ProductJSON-${sectionId}`);
  if (!jsonElement) return;
  const variants = JSON.parse(jsonElement.textContent);
  
  // Flickity Gallery Initialisation
  // Binds the thumbnail slider directly to the main slider instance
  const sliderElem = container.querySelector('.product__image-slider');
  const thumbElem = container.querySelector('.product__image-thumbnail');

  if (sliderElem && typeof Flickity !== 'undefined') {
    const flkty = new Flickity(sliderElem, {
      imagesLoaded: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: true,
      adaptiveHeight: true
    });

    if (thumbElem) {
      new Flickity(thumbElem, {
        asNavFor: sliderElem,
        contain: true,
        pageDots: false,
        prevNextButtons: false
      });
    }

    container._flktyV2 = flkty;
  }

  // Variant Selection Handler
  // Determines if we are dealing with a standard product or a Buy One Get One Free setup
  container.addEventListener('change', function(e) {
    if (e.target.matches('.js-variant-radio')) {
      const fieldset = e.target.closest('fieldset');
      if (fieldset) {
        const selectedValueSpan = fieldset.querySelector('.js-selected-value');
        if (selectedValueSpan) selectedValueSpan.textContent = e.target.value;
      }

      const pickers = container.querySelectorAll('.product-v2__variant-picker');
      
      const v1Options = Array.from(pickers[0].querySelectorAll('.js-variant-radio:checked')).map(r => r.value);
      const v1 = variants.find(v => v1Options.every((val, i) => v.options[i] === val));
      
      let v2 = null;
      if (pickers.length > 1) {
        const v2Options = Array.from(pickers[1].querySelectorAll('.js-variant-radio:checked')).map(r => r.value);
        v2 = variants.find(v => v2Options.every((val, i) => v.options[i] === val));
      }

      if (v1) updateProductUI(v1, v2, container);
    }
  });

  // Master UI Update Logic 
  // Evaluates pricing, badges, button states, and stock validation before updating the DOM
  function updateProductUI(variant, v2, container) {
    const idInput = container.querySelector('.product-variant-id');
    if (idInput) idInput.value = variant.id;
    window.history.replaceState({}, '', `?variant=${variant.id}`);

    const klaviyoSlot = container.querySelector('.klaviyo-favorites-pdp-slot');
    if (klaviyoSlot && variant) {
      klaviyoSlot.setAttribute('data-variant-id', variant.id);
      if (window.klaviyo && window.klaviyo.refreshVariant) {
        window.klaviyo.refreshVariant(variant.id);
      }
    }

    let displayVariant = variant;
    if (v2 && v2.price > variant.price) {
      displayVariant = v2;
    }

    const priceEls = container.querySelectorAll('.js-price');
    const saveEl = container.querySelector('.js-save-price');
    const compEl = container.querySelector('.js-compare-price');

    const formatPrice = (cents) => cents % 100 === 0 ? (cents / 100).toString() : (cents / 100).toFixed(2);

    const priceValue = formatPrice(displayVariant.price);
    const formattedPriceHTML = `<sup class="price-symbol">$</sup>${priceValue}`;
    
    priceEls.forEach(el => {
      el.innerHTML = formattedPriceHTML;
    });

    const saveBadge = container.querySelector('.js-save-badge');
    const compareBadge = container.querySelector('.js-compare-badge');

    if (displayVariant.compare_at_price > displayVariant.price) {
      if (saveEl) saveEl.textContent = `$${formatPrice(displayVariant.compare_at_price - displayVariant.price)}`;
      if (compEl) compEl.textContent = `$${formatPrice(displayVariant.compare_at_price)}`;
      if (saveBadge) saveBadge.classList.remove('is-hidden');
      if (compareBadge) compareBadge.classList.remove('is-hidden');
    } else {
      if (saveBadge) saveBadge.classList.add('is-hidden');
      if (compareBadge) compareBadge.classList.add('is-hidden');
    }

    const afterpayEl = container.querySelector('.js-afterpay-payments');
    if (afterpayEl) {
      const afterpayCents = displayVariant.price / 4;
      afterpayEl.textContent = `$${formatPrice(afterpayCents)}`;
    }

    if (container._flktyV2 && variant.featured_media && variant.featured_media.id !== 0) {
      const slides = Array.from(container.querySelectorAll('.product__image-slider .carousel-cell'));
      const targetIndex = slides.findIndex(s => parseInt(s.dataset.mediaId) === variant.featured_media.id);
      if (targetIndex !== -1) container._flktyV2.select(targetIndex);
    }

    // Availability State Flags
    let isPreorder = false;
    let isBackorder = false;
    const isOOS = variant.inventory_quantity <= 0;
    const continueSelling = variant.inventory_policy === 'continue';
    const hasDispatchDate = variant.estimated_dispatch !== null && variant.estimated_dispatch !== '';

    if (variant.preorder_meta === true || (isOOS && continueSelling && hasDispatchDate)) {
      isPreorder = true;
    } else if (isOOS && continueSelling && !hasDispatchDate) {
      isBackorder = true;
    }
    
    let isComingSoon = (!variant.available && variant.coming_soon);
    
    const btn = container.querySelector('.addToCartBtn');
    
    // Add to Cart Button Behaviour Overrides
    if (btn) {
      const btnLabel = btn.querySelector('.js-atc-label') || btn.querySelector('span');
      const btnPriceWrapper = btn.querySelector('.js-atc-price-wrapper');
      const btnPrice = btn.querySelector('.js-atc-price');
      
      btn.classList.remove('preorder', 'disabled', 'oos');
      btn.disabled = false;

      const v1Available = variant.available || variant.inventory_policy === 'continue';

      let v2Unavailable = false;
      let v2Preorder = false;
      if (v2) {
        const v2Available = v2.available || v2.inventory_policy === 'continue';
        if (!v2Available) v2Unavailable = true;
        
        const v2OOS = v2.inventory_quantity <= 0;
        const v2ContinueSelling = v2.inventory_policy === 'continue';
        const v2HasDispatchDate = v2.estimated_dispatch !== null && v2.estimated_dispatch !== '';

        if (v2.preorder_meta === true || (v2OOS && v2ContinueSelling && v2HasDispatchDate)) {
           v2Preorder = true;
           v2Unavailable = false; 
        }
      }

      if (isPreorder || v2Preorder) {
        btn.classList.add('preorder');
        if (btnLabel) btnLabel.textContent = v2 ? "Pre-Order Both" : "Pre-Order";
        if (btnPriceWrapper) btnPriceWrapper.style.display = "inline";
      } else if (v1Available && !v2Unavailable) {
        if (btnLabel) btnLabel.textContent = v2 ? "Add Both to Cart" : "Add to Cart";
        if (btnPriceWrapper) btnPriceWrapper.style.display = "inline";
      } else if (isComingSoon) {
        btn.disabled = true;
        btn.classList.add('disabled');
        if (btnLabel) btnLabel.textContent = "Coming Soon!";
        if (btnPriceWrapper) btnPriceWrapper.style.display = "none";
      } else {
        btn.disabled = true;
        btn.classList.add('disabled', 'oos');
        if (btnLabel) btnLabel.textContent = v2 ? "SOLD OUT! PICK DIFFERENT SETS" : "WOW! THIS SOLD OUT QUICKLY";
        if (btnPriceWrapper) btnPriceWrapper.style.display = "none";
      }

      if (btnPrice) {
        btnPrice.textContent = `$${formatPrice(displayVariant.price)}`;
      }
    }

    // Dynamic Shipping Text Routing
    const shippingTextEl = container.querySelector('.js-shipping-text');
    const shippingRow = container.querySelector('.js-dynamic-shipping');
    
    if (shippingTextEl && shippingRow) {
      const dispatchTime = variant.estimated_dispatch || 'upcoming';
      
      const v1Available = variant.available || variant.inventory_policy === 'continue';
      let v2Available = true;
      if (v2) {
        v2Available = v2.available || v2.inventory_policy === 'continue';
      }
      const isAvailable = v1Available && v2Available;

      container._currentPrice = displayVariant.price;
      const shippingPrefix = displayVariant.price < 14900 ? "Free Shipping over $149" : "Free Shipping";

      shippingRow.classList.remove('is-preorder', 'is-coming-soon', 'is-oos', 'is-in-stock', 'is-backorder');

      if (isPreorder) {
        shippingRow.classList.add('is-preorder');
        shippingTextEl.innerHTML = `<span class="dynamic-info__highlight">Pre-order</span> <span class="dynamic-info__text">now to reserve yours for our <span class="dynamic-info__bold">${dispatchTime}</span> shipment.</span>`;
      } else if (isBackorder) {
        shippingRow.classList.add('is-backorder');
        shippingTextEl.innerHTML = `<span class="dynamic-info__highlight">${shippingPrefix}:</span> <span class="dynamic-info__text">Order now for secure, tracked delivery.</span>`;
      } else if (isComingSoon) {
        shippingRow.classList.add('is-coming-soon');
        shippingTextEl.innerHTML = `<span class="dynamic-info__text">It's on the way! Check back to grab yours.</span>`;
      } else if (!isAvailable) {
        shippingRow.classList.add('is-oos');
        shippingTextEl.innerHTML = `<span class="dynamic-info__oos-highlight">Out of stock:</span> <span class="dynamic-info__text">Join the waitlist or check back soon to catch the next drop.</span>`;
      } else {
        shippingRow.classList.add('is-in-stock');
        shippingTextEl.innerHTML = `<span class="js-shipping-timer-target"></span>`;
        updateShippingTimer(); 
      }

      if (!shippingRow.classList.contains('is-ready')) {
        setTimeout(() => {
          shippingRow.classList.add('is-ready');
        }, 50);
      }
    }
  }
    
  // Dynamic Shipping Timer & Intersection Observer
  // Ensures calculations are done in Sydney local time
  let shippingInterval;

  function updateShippingTimer() {
    const timerTargets = container.querySelectorAll('.js-shipping-timer-target');
    const shippingRow = container.querySelector('.js-dynamic-shipping');

    if (timerTargets.length === 0 || !shippingRow || !shippingRow.classList.contains('is-in-stock')) return;

    const sydneyTimeString = new Date().toLocaleString("en-US", { timeZone: "Australia/Sydney" });
    const now = new Date(sydneyTimeString);
    let target = new Date(now);

    let shipDayText = "";
    const day = now.getDay(); 
    const hour = now.getHours();

    const overrideDateStr = container.dataset.dispatchOverride;
    let isOverrideActive = false;

    // 1. Holiday Dispatch Override Metafield
    if (overrideDateStr) {
      const overrideParts = overrideDateStr.split('-');
      if (overrideParts.length === 3) {
        const overrideDate = new Date(now);
        overrideDate.setFullYear(parseInt(overrideParts[0], 10));
        overrideDate.setMonth(parseInt(overrideParts[1], 10) - 1);
        overrideDate.setDate(parseInt(overrideParts[2], 10));
        overrideDate.setHours(12, 0, 0, 0); // Sets target to 12pm of the metafield date

        if (now < overrideDate) {
          target = overrideDate;
          shipDayText = "next-business-day dispatch";
          isOverrideActive = true;
        }
      }
    }

    // 2. Standard & Weekend Logic
    if (!isOverrideActive) {
      // Weekend override: Friday 12pm through to Monday 11:59am
      if ((day === 5 && hour >= 12) || day === 6 || day === 0 || (day === 1 && hour < 12)) {
        if (day === 5) target.setDate(target.getDate() + 3);      // Fri -> Mon
        else if (day === 6) target.setDate(target.getDate() + 2); // Sat -> Mon
        else if (day === 0) target.setDate(target.getDate() + 1); // Sun -> Mon
        // If day === 1 (Monday), target remains today

        target.setHours(12, 0, 0, 0); // Countdown to 12pm Monday
        shipDayText = "next-business-day dispatch";
      } else {
        // Base logic for standard weekdays
        if (hour < 12) {
          // 12am - 11:59am
          target.setHours(12, 0, 0, 0); // Next 12pm today
          shipDayText = "same-day dispatch";
        } else {
          // 12pm - 11:59pm
          target.setDate(target.getDate() + 1);
          target.setHours(0, 0, 0, 0); // Next 12am tomorrow
          shipDayText = "next-day dispatch";
        }
      }
    }

    const diff = target - now;

    const h = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, '0');
    const m = String(Math.floor((diff / 1000 / 60) % 60)).padStart(2, '0');
    const s = String(Math.floor((diff / 1000) % 60)).padStart(2, '0');

    const currentPrice = container._currentPrice || 0;
    const shippingPrefix = (currentPrice > 0 && currentPrice < 14900) ? "Free Shipping for orders over $149" : "Free Shipping";

    const html = `<span class="dynamic-info__highlight">${shippingPrefix}:</span> <span class="dynamic-info__text">Order within <span class="dynamic-info__bold">${h}:${m}:${s}</span> for <span class="dynamic-info__bold">${shipDayText}</span></span>`;

    timerTargets.forEach(el => {
      el.innerHTML = html;
    });
  }

  // Prevents the timer from ticking away CPU cycles if it is not currently visible on screen
  const shippingContainer = container.querySelector('.js-dynamic-shipping');
  
  if (shippingContainer && typeof IntersectionObserver !== 'undefined') {
    const timerObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          updateShippingTimer(); 
          shippingInterval = setInterval(updateShippingTimer, 1000);
        } else {
          clearInterval(shippingInterval);
        }
      });
    }, { threshold: 0 });

    timerObserver.observe(shippingContainer);
  } else {
    setInterval(updateShippingTimer, 1000);
  }

  const initialCheckedRadios = Array.from(container.querySelectorAll('.js-variant-radio:checked'));
  if (initialCheckedRadios.length > 0) {
      const event = new Event('change', { bubbles: true });
      initialCheckedRadios[0].dispatchEvent(event);
  } else if (variants && variants.length > 0) {
      updateProductUI(variants[0], null, container);
  }

  // Cart API Hijack for Bundled/BOGOF Purchases
  // Consolidates variants into a single array to post to /cart/add.js
  const pickersForCart = container.querySelectorAll('.product-v2__variant-picker');
  const btn = container.querySelector('.addToCartBtn');
  
  if (btn && pickersForCart.length > 1) {
    btn.addEventListener('click', async function() {
      
      const btnLabel = btn.querySelector('.js-atc-label') || btn.querySelector('span');
      const btnPriceWrapper = btn.querySelector('.js-atc-price-wrapper');
      const originalText = btnLabel ? btnLabel.textContent : btn.textContent;
      
      if (btnLabel) btnLabel.textContent = "Adding...";
      else btn.textContent = "Adding...";
      if (btnPriceWrapper) btnPriceWrapper.style.display = "none";
      btn.disabled = true;

      const v1Options = Array.from(pickersForCart[0].querySelectorAll('.js-variant-radio:checked, input[type="radio"]:checked, select')).map(r => r.value);
      const v2Options = Array.from(pickersForCart[1].querySelectorAll('.js-variant-radio:checked, input[type="radio"]:checked, select')).map(r => r.value);
      
      const v1 = variants.find(v => v1Options.every((val, i) => v.options[i] === val));
      const v2 = variants.find(v => v2Options.every((val, i) => v.options[i] === val));

      if (!v1 || !v2) {
        console.error("Cart API: Variant match failed.");
        if (btnLabel) btnLabel.textContent = originalText;
        else btn.textContent = originalText;
        if (btnPriceWrapper) btnPriceWrapper.style.display = "inline";
        btn.disabled = false;
        return;
      }

      let items = [];
      if (v1.id === v2.id) {
        items = [{ id: v1.id, quantity: 2 }];
      } else {
        items = [{ id: v1.id, quantity: 1 }, { id: v2.id, quantity: 1 }];
      }

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items })
        });

        if (res.ok) {
          fetch("/cart.js")
            .then(response => response.json())
            .then(cart => {
              if (btnLabel) btnLabel.textContent = originalText;
              else btn.textContent = originalText;
              if (btnPriceWrapper) btnPriceWrapper.style.display = "inline";
              btn.disabled = false;
            });
        } else {
          console.error(await res.json());
          if (btnLabel) btnLabel.textContent = originalText;
          else btn.textContent = originalText;
          if (btnPriceWrapper) btnPriceWrapper.style.display = "inline";
          btn.disabled = false;
        }
      } catch (err) {
        console.error(err);
        if (btnLabel) btnLabel.textContent = originalText;
        else btn.textContent = originalText;
        if (btnPriceWrapper) btnPriceWrapper.style.display = "inline";
        btn.disabled = false;
      }
    });
  }

  // UI Interactions (Zoom Lightbox, Accordions, Modal, Smooth Scroll)
  const zoomBtn = container.querySelector('.customimagezoom-btn');
  if (zoomBtn) {
    zoomBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const activeSlide = container.querySelector('.product__image-slider .carousel-cell.is-selected');
      if (activeSlide) {
        const activeLightboxLink = activeSlide.querySelector('a.fslightbox');
        if (activeLightboxLink) {
          activeLightboxLink.click();
        }
      }
    });
  }

  const accordions = container.querySelectorAll('.product-accordion');
  accordions.forEach(acc => {
    const titleBtn = acc.querySelector('.product-accordion__title');
    const closeBtn = acc.querySelector('.product-accordion__close-link');
    
    if (titleBtn) {
      titleBtn.addEventListener('click', () => {
        const isOpen = acc.classList.contains('is-open');

        if (isOpen) {
          acc.classList.remove('is-open');
          titleBtn.setAttribute('aria-expanded', 'false');
        } else {
          acc.classList.add('is-open');
          titleBtn.setAttribute('aria-expanded', 'true');
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        
        acc.classList.remove('is-open');
        if (titleBtn) titleBtn.setAttribute('aria-expanded', 'false');
        
        const rect = acc.getBoundingClientRect();
        
        if (rect.top < 100) {
          const elementPosition = rect.top + window.pageYOffset;
          
          window.scrollTo({
               top: elementPosition - 100, 
               behavior: 'smooth'
          });
        }
      });
    }
  });

  // Sister Products Modal with Focus Trap functionality
  const sisterTrigger = container.querySelector('.js-sister-popup-trigger');
  const popupContainer = container.querySelector(`#SisterPopup-${sectionId}`);
  
  if (sisterTrigger && popupContainer) {
    const backdrop = popupContainer.querySelector('.sp-backdrop');
    const closeBtn = popupContainer.querySelector('.sp-close-btn');
    const headingTarget = popupContainer.querySelector('.sp-inner-heading');
    const contentTarget = popupContainer.querySelector('.sp-scroll-area');
    
    let contentLoaded = false;
    const focusableElementsString = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    let firstFocusableElement;
    let lastFocusableElement;

    function openPopup(e) {
      e.preventDefault(); 
      const contentUrl = sisterTrigger.getAttribute('href');
      
      if (!contentUrl || contentUrl === '#' || contentUrl === '') return;

      document.body.classList.add('sp-active');
      popupContainer.setAttribute('aria-hidden', 'false');

      const focusableContent = popupContainer.querySelectorAll(focusableElementsString);
      if (focusableContent.length > 0) {
        firstFocusableElement = focusableContent[0];
        lastFocusableElement = focusableContent[focusableContent.length - 1];
      }
      
      if (closeBtn) closeBtn.focus();
      
      if (!contentLoaded) {
        fetch(contentUrl)
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            const fetchedHeading = doc.querySelector('.rich-text__heading') || doc.querySelector('h1') || doc.querySelector('.section-header__title');
            const fetchedContent = doc.querySelector('.content-for-layout') || doc.querySelector('main');

            if(headingTarget && fetchedHeading) headingTarget.innerHTML = fetchedHeading.innerText;
            if(contentTarget && fetchedContent) contentTarget.innerHTML = fetchedContent.innerHTML;
            
            const unwantedSections = contentTarget.querySelectorAll('section:nth-child(1), section:nth-child(2)');
            unwantedSections.forEach(el => el.style.display = 'none');

            contentLoaded = true;

            const updatedFocusableContent = popupContainer.querySelectorAll(focusableElementsString);
            if (updatedFocusableContent.length > 0) {
              firstFocusableElement = updatedFocusableContent[0];
              lastFocusableElement = updatedFocusableContent[updatedFocusableContent.length - 1];
            }
          })
          .catch(err => {
            console.error('Error loading comparison content:', err);
            if(contentTarget) contentTarget.innerHTML = '<p>Content could not be loaded.</p>';
          });
      }
    }

    function closePopup() {
      document.body.classList.remove('sp-active');
      popupContainer.setAttribute('aria-hidden', 'true');
      if (sisterTrigger) sisterTrigger.focus();
    }

    // Cycles through elements within the popup so keyboard users are not stuck
    popupContainer.addEventListener('keydown', function(e) {
      const isTabPressed = e.key === 'Tab' || e.keyCode === 9;
      if (!isTabPressed) return;

      if (e.shiftKey) { 
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus();
          e.preventDefault();
        }
      } else { 
        if (document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus();
          e.preventDefault();
        }
      }
    });

    sisterTrigger.addEventListener('click', openPopup);
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (backdrop) backdrop.addEventListener('click', closePopup);
    
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && document.body.classList.contains('sp-active')) {
        closePopup();
      }
    });
  }

  // Dynamic review scroll tracker
  // Updates destination calculation constantly to account for lazy-loaded assets shifting the page layout
  container.addEventListener('click', function (e) {
    const reviewLink = e.target.closest('.mainproductreviews-v2');
    
    if (reviewLink) {
      e.preventDefault();
      e.stopPropagation();

      const scrollTarget = document.querySelector('[data-oke-widget]') || document.querySelector('#okendo-reviews-widget');
      
      if (scrollTarget) {
        const offset = 100;
        const duration = 800; 
        const startY = window.pageYOffset;
        let startTime = null;
        let animationFrame;

        const easeOutQuart = (t) => 1 - (--t) * t * t * t; 

        const step = (currentTime) => {
          if (!startTime) startTime = currentTime;
          const timeElapsed = currentTime - startTime;
          const progress = Math.min(timeElapsed / duration, 1);
          const easing = easeOutQuart(progress);

          const targetY = scrollTarget.getBoundingClientRect().top + window.pageYOffset - offset;
          const currentY = startY + (targetY - startY) * easing;

          window.scrollTo(0, currentY);

          if (timeElapsed < duration) {
            animationFrame = window.requestAnimationFrame(step);
          }
        };

        const stopAnimation = () => window.cancelAnimationFrame(animationFrame);
        window.addEventListener('wheel', stopAnimation, { once: true, passive: true });
        window.addEventListener('touchstart', stopAnimation, { once: true, passive: true });

        animationFrame = window.requestAnimationFrame(step);
      }
    }
  });
});